import type { ReactNode } from 'react';
import { Reveal } from '@/components/fx/Reveal';
import { Headline } from '@/components/fx/Headline';

interface PageHeroProps {
  eyebrow: string;
  title: string;
  highlight?: string[];
  lede: string;
  aside?: ReactNode;
}

/** Opening block shared by every inner page: eyebrow, headline, lede, aside. */
export function PageHero({ eyebrow, title, highlight = [], lede, aside }: PageHeroProps) {
  return (
    <section className={`page-hero${aside ? ' page-hero--split' : ''}`}>
      <div className="shell page-hero__grid">
        <div className="page-hero__copy">
          <Reveal as="p" className="eyebrow">
            {eyebrow}
          </Reveal>
          <Headline
            as="h1"
            className="display display--section page-hero__title"
            text={title}
            highlight={highlight}
          />
          <Reveal as="p" className="lede" delay={340}>
            {lede}
          </Reveal>
        </div>
        {aside ? (
          <Reveal className="page-hero__aside" delay={460}>
            {aside}
          </Reveal>
        ) : null}
      </div>
    </section>
  );
}
